import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPhone'
})
export class FormatPhone implements PipeTransform {

	
	private readonly PHONE_REGEX = /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
	  private readonly PHONE_PREFIX = /\+?(1)?/;
	  private readonly SPACES = /\s+/g;
	  private readonly POINTS = /\.+/g;
	  
	  transform(value: string): string {
	    let trimmed = value.replace(this.SPACES, '');
		trimmed = trimmed.replace(this.POINTS, '');
	    trimmed = trimmed.replace(this.PHONE_PREFIX, '');

	    const matches = trimmed.match(this.PHONE_REGEX);

	    if (!matches) {
	      return value;
	    }

	    const phoneParts = matches.slice(1,);
	    return phoneParts.join(' ');
	  }
	/*
	transform(value: string): string {
		//console.log("tel trnasform",value)
	    let result= value.replace(/(\d{1,2})([\s\.]{0,1})(\d{1,2})([\s\.]{0,1})(\d{1,2})([\s\.]{0,1})(\d{1,2})([\s\.]{0,1})(\d{1,2})/, '$1-$3-$5-$7-$9');
		console.log("tel transform",value,result)
		return result;
	  }
	*/
	/*transform(value: any, ...args: any[]): any {

        let result = "";
        if (value && value.length>0) {
	        let numberArray = value.split("");
	        if (numberArray!=undefined 
	        && numberArray 
	        && Array.isArray(numberArray))
		        numberArray.forEach((number, index) => {
		            let space = "";
		            if (index !== 0 && (index % 2) !== 1) {
		                space = " ";
		            }
		            result += space + number;
		        });
		}			
        return result;
    }
	*/

}
